<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            <i id="backArrow" @click="openCat" class="fas fa-chevron-circle-left"></i>  {{title}}{{Cname}}
          </h3>
        </div>
        <div class="col text-right">
          <button @click="newsub()" type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#exampleModal">Add new</button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
        <vue-good-table
          :line-numbers="true"
          :columns="columns"
          :rows="rows"
          :pagination-options="{
              enabled: true,
              mode: 'pages',
              perPage: 10
              }"
          :search-options="{
            enabled: true,
            placeholder: 'Search this table',
            }"
          >
              <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'action'">
          <button class="btn btn-success btn-sm" @click="openbrands(props.row.id,props.row.name)" >brands</button>
          <button @click="updateSub(props.row)" type="button" class="btn btn-sm btn-primary btn-circle">
              <i class="fas fa-edit"></i>
          </button>  
          <button @click="deleteSub(props.row.id)" type="button" class="btn btn-danger btn-sm btn-circle">
              <i class="fas fa-trash"></i>
          </button>
        </span>
        <span v-else>
          {{props.formattedRow[props.column.field]}}
        </span>
      </template>
      
      </vue-good-table>
    </div>

    
    <newSubCategory @reload="getSubCategories" :Cname="Cname" :form="form"></newSubCategory>
    <div class="vld-parent">
            <loading name="loader" :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="fullPage">
            </loading>
  </div>
  </div>
</template>
<script>
  import newSubCategory from '../modals/NewSubcategory'
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";
  export default {
    name: 'SubcategoriesTable',
    components:{
      newSubCategory,
      Loading
    },
    props: {
      type:String,
      id: Number,
      title: String,
      Cname:String,
    },
    data() {
      return {
        form:{
              id: 0,
              name: '',
              Cid: this.id,
          },
        fullPage:true,
        isLoading:false,
        columns: [
        {
          label: 'Name',
          field: 'name',
        },
        {
          label: 'Actions',
          field: 'action',
          
        },
        ],
        rows: [],
        subcategories:{
          id: 0,
          name: ''
        }
      }
    },
    created(){
      this.getSubCategories();
    },
    methods:{
      newsub(){
        this.form.id = 0;
        this.form.name = '';
        this.form.Cid = this.id;
      },
      getSubCategories(){
        let path = 'admin/shopLocal/sub-category/' + this.id;
        this.axios.get(path)
        .then((response)=>{
          this.rows = response.data
        })
      },
      openbrands(id, name){
        this.subcategories.id = id;
        this.subcategories.name = name;
        this.$emit("openBrands",this.subcategories);
      },
      openCat(){
        this.$emit("opencat");
      },
      deleteSub(id) {
                this.$swal({ 
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    // send the request to the controller
                    if (result.value) {
                      this.isLoading = true;
                        this.axios.delete('/admin/shopLocal/Subcategory/' + id).then(() => {
                            this.isLoading = false;
                            this.$swal(
                                'Deleted!',
                                'Category has been deleted.',
                                'success'
                            )
                            this.getSubCategories();
                        })
                        .catch(() => {
                            this.isLoading = false;
                            this.$swal("Failed!", "There was something wrong.", "warning");
                })
                    }
                })
            },
            updateSub(row){
              this.form.id = row.id;
              this.form.name = row.name;
              $('#exampleModal').modal('show');
            }
    }
  }
</script>
<style>
  #backArrow{
    font-size: 30px;
    color: green;
    margin-right: 20px;
  }
  #backArrow:hover{
    cursor: pointer;
    color: greenyellow;
    transition-duration: 1s;
  }
</style>
